export const FeatureFlags = [
    'malt-start-links',
    'activate-profile-session-replay',
    'profile-view-blocker',
    'new-profile-account-creation',
    'suggest-skills-when-updating-experience',
    'amplitude-recording-for-profile-experiences',
    'amplitude-recording-for-profile',
    'amplitude-recording-for-freelancer-signup',
    'update-task-list-and-card-for-experiences',
    'update-task-list-in-line-with-new-incentives',
    'client-instant-conversation',
    'split-profile-skills',
    'search-proposal-singapore',
    'enable-async-translation-front',
    'client-instant-conversation-unlogged',
    'malt-dot-com-compliant-freelancer-signup',
] as const;

export type FeatureFlag = (typeof FeatureFlags)[number];

export type FeatureContext = Record<FeatureFlag, boolean | undefined>;
